export default __webpack_public_path__ + "static/media/NOTO_SANS_KR_600.ee36d41f.ttf";